module.exports = __webpack_public_path__ + "img/Top.ee9ceab9.png";